import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { PAIA_URL } from "@util/constant";

/**
 * Component to render Paia section on Partners page
 */
const PaiaSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="paia-section-component">
      <AccordionV2
        testId="paia"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader title="Paia" className="px-0" />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            We are a team of dedicated sustainability specialists committed to
            working alongside companies to understand the business risks and
            opportunities that sustainability issues pose, and how best to apply
            those within existing company structures and strategies. Paia has a
            solid reputation as the leading consultancy in Singapore, and work
            on a retained basis with the majority of our clients. We have a
            depth of expertise that is unparalleled locally.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={PAIA_URL}
              target="_blank"
              rel="noreferrer"
            >
              https://paiaconsulting.com.sg/
            </a>
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default PaiaSection;
